import React, { useState } from 'react'
import PageTitleAndSnackBar from '../../components/common/PageTitleAndSnackBar'

const Wallet = () => {
  const walletBalance = 48750.00;

  const [transactions, setTransactions] = useState([
    { id:1,  type:'credit',  icon:'bi-arrow-down-circle-fill', iconColor:'text-success', title:'Balance Added',       description:'Wallet recharged via NEFT transfer. Ref: NEFT2024001',      amount:20000, date:'08 Apr 2026', time:'10:32 AM', status:'completed', txnId:'TXN2026040801' },
    { id:2,  type:'debit',   icon:'bi-arrow-up-circle-fill',   iconColor:'text-danger',  title:'Booking Payment',     description:'Ticket issued for BK2026003 - DEL to BOM. PNR: AB1234',     amount:8450,  date:'07 Apr 2026', time:'03:15 PM', status:'completed', txnId:'TXN2026040702' },
    { id:3,  type:'credit',  icon:'bi-gift-fill',               iconColor:'text-primary', title:'Commission Received', description:'Commission credited for March 2026 bookings.',               amount:3200,  date:'06 Apr 2026', time:'11:00 AM', status:'completed', txnId:'TXN2026040601' },
    { id:4,  type:'debit',   icon:'bi-arrow-up-circle-fill',   iconColor:'text-danger',  title:'Booking Payment',     description:'Ticket issued for BK2026008 - BOM to CCU. PNR: CD5678',     amount:12300, date:'05 Apr 2026', time:'09:45 AM', status:'completed', txnId:'TXN2026040501' },
    { id:5,  type:'credit',  icon:'bi-arrow-counterclockwise', iconColor:'text-info',    title:'Refund Received',     description:'Refund processed for cancelled booking BK2026005.',          amount:6500,  date:'04 Apr 2026', time:'02:20 PM', status:'completed', txnId:'TXN2026040402' },
    { id:6,  type:'debit',   icon:'bi-arrow-up-circle-fill',   iconColor:'text-danger',  title:'Booking Payment',     description:'Ticket issued for BK2026010 - DEL to GOA. PNR: GH3456',     amount:9800,  date:'03 Apr 2026', time:'04:50 PM', status:'completed', txnId:'TXN2026040301' },
    { id:7,  type:'pending', icon:'bi-clock-fill',              iconColor:'text-warning', title:'Withdrawal Request',  description:'Withdrawal to bank account HDFC ****4532 pending approval.', amount:15000, date:'02 Apr 2026', time:'01:10 PM', status:'pending',   txnId:'TXN2026040201' },
    { id:8,  type:'credit',  icon:'bi-arrow-down-circle-fill', iconColor:'text-success', title:'Balance Added',       description:'Wallet recharged via UPI. Ref: UPI2026040101',               amount:25000, date:'01 Apr 2026', time:'08:30 AM', status:'completed', txnId:'TXN2026040101' },
    { id:9,  type:'debit',   icon:'bi-arrow-up-circle-fill',   iconColor:'text-danger',  title:'Booking Payment',     description:'Ticket issued for BK2026012 - HYD to DEL. PNR: IJ7890',     amount:7650,  date:'31 Mar 2026', time:'11:55 AM', status:'completed', txnId:'TXN2026033101' },
    { id:10, type:'credit',  icon:'bi-gift-fill',               iconColor:'text-primary', title:'Bonus Credited',      description:'Welcome bonus credited to your wallet. Valid for 30 days.',  amount:500,   date:'30 Mar 2026', time:'10:00 AM', status:'completed', txnId:'TXN2026033001' },
  ]);

  const [filter, setFilter] = useState('all');

  const filteredTransactions = transactions.filter(txn =>
    filter === 'all' ? true : txn.type === filter
  );

  const totalCreditsAmt = transactions.filter(t => t.type === 'credit'  && t.status === 'completed').reduce((sum, t) => sum + t.amount, 0);
  const totalDebitsAmt  = transactions.filter(t => t.type === 'debit'   && t.status === 'completed').reduce((sum, t) => sum + t.amount, 0);
  const pendingAmt      = transactions.filter(t => t.status === 'pending').reduce((sum, t) => sum + t.amount, 0);

  const fmt = (amt) => new Intl.NumberFormat('en-IN', { minimumFractionDigits: 2 }).format(amt);

  return (
    <>
      <PageTitleAndSnackBar pageTitle="Wallet" />

      <section className="section">

        {/* Top Row: Balance + Stats */}
        <div className="row g-3 mb-4">

          {/* Balance Card */}
          <div className="col-12 col-md-5">
            <div className="card h-100 border-0" style={{
              background: "linear-gradient(135deg, #2d4f8e 0%, #4a72b8 100%)",
              borderRadius: "16px", overflow: "hidden", position: "relative",
              boxShadow: "0 4px 20px rgba(45,79,142,0.2)"
            }}>
              <div style={{ position:"absolute", top:"-30px", right:"-30px", width:"130px", height:"130px", borderRadius:"50%", background:"rgba(255,255,255,0.07)" }}></div>
              <div style={{ position:"absolute", bottom:"-20px", right:"60px",  width:"80px",  height:"80px",  borderRadius:"50%", background:"rgba(255,255,255,0.05)" }}></div>

              <div className="card-body p-4 text-white" style={{ position:"relative", zIndex:1 }}>
                <div className="d-flex justify-content-between align-items-start mb-1">
                  <div>
                    <p className="mb-1" style={{ fontSize:"11px", fontWeight:700, letterSpacing:"1.2px", color:"rgba(255,255,255,0.65)", textTransform:"uppercase" }}>
                      Available Balance
                    </p>
                    <h2 className="fw-bold mb-0 text-white" style={{ fontSize:"32px", letterSpacing:"-0.5px" }}>
                      ₹{fmt(walletBalance)}
                    </h2>
                    <p className="mb-0 mt-1" style={{ fontSize:"11px", color:"rgba(255,255,255,0.5)" }}>Last updated: Today, 10:32 AM</p>
                  </div>
                  <div style={{ width:"50px", height:"50px", borderRadius:"14px", background:"rgba(255,255,255,0.14)", display:"flex", alignItems:"center", justifyContent:"center" }}>
                    <i className="bi bi-wallet2" style={{ fontSize:"21px" }}></i>
                  </div>
                </div>

                <div className="d-flex gap-2 mt-4">
                  <button className="btn btn-sm fw-semibold d-flex align-items-center gap-2 px-3" style={{
                    background:"rgba(255,255,255,0.92)", color:"#2d4f8e",
                    borderRadius:"8px", border:"none", fontSize:"12px", height:"34px",
                    boxShadow:"0 2px 8px rgba(0,0,0,0.12)"
                  }}>
                    <i className="bi bi-plus-circle-fill" style={{ fontSize:"13px" }}></i> Add Money
                  </button>
                  <button className="btn btn-sm fw-semibold d-flex align-items-center gap-2 px-3" style={{
                    background:"rgba(255,255,255,0.13)", color:"rgba(255,255,255,0.88)",
                    borderRadius:"8px", border:"1.5px solid rgba(255,255,255,0.22)",
                    fontSize:"12px", height:"34px"
                  }}>
                    <i className="bi bi-bank" style={{ fontSize:"13px" }}></i> Withdraw
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Stats */}
          <div className="col-12 col-md-7">
            <div className="row g-3 h-100">
              {[
                { label:"Total Credits", value:totalCreditsAmt, icon:"bi-arrow-down-circle-fill", iconBg:"#edf7f2", iconColor:"#3a8c63", valueColor:"#3a8c63", accent:"#7bbfa0" },
                { label:"Total Debits",  value:totalDebitsAmt,  icon:"bi-arrow-up-circle-fill",   iconBg:"#fdf2f2", iconColor:"#c05252", valueColor:"#c05252", accent:"#e0a0a0" },
                { label:"Pending",       value:pendingAmt,       icon:"bi-clock-fill",              iconBg:"#fdf8ee", iconColor:"#b07828", valueColor:"#b07828", accent:"#e0c070" },
              ].map(stat => (
                <div className="col-12 col-sm-4" key={stat.label}>
                  <div className="card h-100 border-0" style={{
                    borderRadius:"14px",
                    border:`1.5px solid #edf0f7`,
                    boxShadow:"0 2px 10px rgba(45,79,142,0.06)",
                    borderLeft:`4px solid ${stat.accent}`
                  }}>
                    <div className="card-body p-3">
                      <div className="d-flex align-items-center gap-2 mb-3">
                        <div style={{ width:"34px", height:"34px", borderRadius:"10px", background:stat.iconBg, display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0 }}>
                          <i className={`bi ${stat.icon}`} style={{ fontSize:"14px", color:stat.iconColor }}></i>
                        </div>
                        <span style={{ fontSize:"11px", fontWeight:700, color:"#9aaabe", textTransform:"uppercase", letterSpacing:"0.6px" }}>
                          {stat.label}
                        </span>
                      </div>
                      <h5 className="fw-bold mb-0" style={{ fontSize:"18px", color:stat.valueColor }}>
                        ₹{fmt(stat.value)}
                      </h5>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Transaction History */}
        <div className="row">
          <div className="col-12">
            <div className="card border-0" style={{ borderRadius:"16px", boxShadow:"0 2px 16px rgba(45,79,142,0.07)", border:"1.5px solid #edf0f7" }}>
              <div className="card-body p-4">

                {/* Header */}
                <div className="d-flex align-items-center justify-content-between mb-4 flex-wrap gap-3">
                  <div className="d-flex align-items-center gap-2">
                    <div style={{ width:"36px", height:"36px", borderRadius:"10px", background:"#e8edf8", display:"flex", alignItems:"center", justifyContent:"center" }}>
                      <i className="bi bi-clock-history" style={{ fontSize:"15px", color:"#2d4f8e" }}></i>
                    </div>
                    <div>
                      <h6 className="mb-0 fw-bold" style={{ color:"#1e3a6e", fontSize:"14px" }}>Transaction History</h6>
                      <span style={{ fontSize:"11px", color:"#9aaabe" }}>
                        <strong style={{ color:"#4a72b8" }}>{filteredTransactions.length}</strong> transactions
                      </span>
                    </div>
                  </div>
                  <button className="btn btn-sm fw-semibold d-flex align-items-center gap-2" style={{
                    background:"#f4f6fb", color:"#5b6b82",
                    border:"1.5px solid #e4e9f2", borderRadius:"8px",
                    fontSize:"12px", height:"34px", padding:"0 14px"
                  }}>
                    <i className="bi bi-download" style={{ color:"#4a72b8" }}></i> Export
                  </button>
                </div>

                {/* Filter Pills */}
                <div style={{ overflowX:"auto", paddingBottom:4, marginBottom:20 }}>
                  <div className="d-flex gap-2" style={{ flexWrap:"nowrap", minWidth:"max-content" }}>
                    {[
                      { val:"all",     label:"All Transactions", icon:"bi-list-ul" },
                      { val:"credit",  label:"Credits",          icon:"bi-arrow-down-circle-fill" },
                      { val:"debit",   label:"Debits",           icon:"bi-arrow-up-circle-fill" },
                      { val:"pending", label:"Pending",          icon:"bi-clock-fill" },
                    ].map(f => (
                      <button key={f.val} onClick={() => setFilter(f.val)}
                        className="btn btn-sm d-flex align-items-center gap-2 fw-semibold"
                        style={{
                          borderRadius:"20px", fontSize:"12px", height:"32px",
                          padding:"0 14px", whiteSpace:"nowrap",
                          border: filter === f.val ? "none" : "1.5px solid #e4e9f2",
                          background: filter === f.val ? "linear-gradient(135deg, #2d4f8e, #4a72b8)" : "white",
                          color: filter === f.val ? "white" : "#7a8ca0",
                          boxShadow: filter === f.val ? "0 3px 10px rgba(45,79,142,0.22)" : "none",
                          transition:"all 0.15s"
                        }}>
                        <i className={`bi ${f.icon}`} style={{ fontSize:"11px" }}></i>
                        {f.label}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Transaction List */}
                <div className="d-flex flex-column gap-2">
                  {filteredTransactions.length === 0 ? (
                    <div className="text-center py-5">
                      <div style={{ width:60, height:60, borderRadius:16, background:"#f4f6fb", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 12px" }}>
                        <i className="bi bi-inbox" style={{ fontSize:"26px", color:"#c5cfe0" }}></i>
                      </div>
                      <p className="fw-semibold mb-1" style={{ fontSize:"14px", color:"#4b5563" }}>No transactions found</p>
                      <p style={{ fontSize:"12px", color:"#9aaabe" }}>There are no transactions matching the selected filter.</p>
                    </div>
                  ) : (
                    filteredTransactions.map(txn => {
                      const isCredit  = txn.type === "credit";
                      const isPending = txn.type === "pending";
                      const amtColor  = isCredit ? "#3a8c63" : isPending ? "#b07828" : "#c05252";
                      const amtBg     = isCredit ? "#edf7f2" : isPending ? "#fdf8ee" : "#fdf2f2";
                      const iconBg    = isCredit ? "#edf7f2" : isPending ? "#fdf8ee" : "#fdf2f2";
                      const iconColor = isCredit ? "#3a8c63" : isPending ? "#b07828" : "#c05252";
                      const stsBg     = txn.status === "completed" ? "#edf7f2" : txn.status === "pending" ? "#fdf8ee" : "#fdf2f2";
                      const stsColor  = txn.status === "completed" ? "#3a8c63" : txn.status === "pending" ? "#b07828" : "#c05252";

                      return (
                        <div key={txn.id}
                          style={{ borderRadius:"12px", border:"1.5px solid #edf0f7", background:"white", transition:"all 0.15s", cursor:"default" }}
                          onMouseEnter={e => { e.currentTarget.style.background="#f8f9fe"; e.currentTarget.style.borderColor="#dde3ef"; }}
                          onMouseLeave={e => { e.currentTarget.style.background="white";   e.currentTarget.style.borderColor="#edf0f7"; }}
                        >
                          <div className="d-flex align-items-start gap-3 p-3">
                            {/* Icon */}
                            <div style={{ width:"42px", height:"42px", borderRadius:"12px", flexShrink:0, background:iconBg, display:"flex", alignItems:"center", justifyContent:"center" }}>
                              <i className={`bi ${txn.icon}`} style={{ fontSize:"17px", color:iconColor }}></i>
                            </div>

                            {/* Details */}
                            <div className="flex-grow-1" style={{ minWidth:0 }}>
                              {/* Title + Amount */}
                              <div className="d-flex justify-content-between align-items-start gap-2 flex-wrap">
                                <p className="mb-0 fw-bold" style={{ fontSize:"13px", color:"#1e3a6e" }}>{txn.title}</p>
                                <span style={{ fontSize:"14px", fontWeight:800, color:amtColor, background:amtBg, borderRadius:"8px", padding:"3px 10px", flexShrink:0 }}>
                                  {isCredit ? "+" : isPending ? "" : "−"}₹{fmt(txn.amount)}
                                </span>
                              </div>

                              {/* Description */}
                              <p className="mb-2 text-truncate" style={{ fontSize:"12px", color:"#7a8ca0", marginTop:2 }}>
                                {txn.description}
                              </p>

                              {/* Meta chips */}
                              <div className="d-flex align-items-center gap-2 flex-wrap">
                                <span style={{ fontSize:"10px", color:"#9aaabe", background:"#f4f6fb", borderRadius:"6px", padding:"2px 8px", fontWeight:600 }}>
                                  <i className="bi bi-calendar3 me-1"></i>{txn.date}
                                </span>
                                <span style={{ fontSize:"10px", color:"#9aaabe", background:"#f4f6fb", borderRadius:"6px", padding:"2px 8px", fontWeight:600 }}>
                                  <i className="bi bi-clock me-1"></i>{txn.time}
                                </span>
                                <span style={{ fontSize:"10px", color:"#4a72b8", background:"#e8edf8", borderRadius:"6px", padding:"2px 8px", fontWeight:700, fontFamily:"monospace" }}>
                                  {txn.txnId}
                                </span>
                                <span style={{ fontSize:"10px", fontWeight:700, borderRadius:"6px", padding:"2px 8px", background:stsBg, color:stsColor }}>
                                  {txn.status.toUpperCase()}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })
                  )}
                </div>

                {/* Load More */}
                {filteredTransactions.length > 0 && (
                  <div className="text-center mt-4">
                    <button className="btn btn-sm fw-semibold d-flex align-items-center gap-2 mx-auto" style={{
                      background:"#f4f6fb", color:"#5b6b82",
                      border:"1.5px solid #e4e9f2", borderRadius:"8px",
                      fontSize:"12px", height:"34px", padding:"0 20px"
                    }}>
                      <i className="bi bi-arrow-clockwise" style={{ color:"#4a72b8" }}></i> Load More
                    </button>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>

      </section>
    </>
  );
}

export default Wallet